<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="onboarding-driver">
  <div class="driver-img">
    <img src="../../../../assets/images/parking-admin-banner.jpg" alt="Parking admin"/>
  </div>
  <div class="ondriver-text">
    <form [formGroup]="createDriverForm">
      <div class="driver-text">
        <h4>Parking Manager</h4>
      </div>
      <div class="grid">
        <div class="col-12 lg:col-3">
          <div class="common-label">
            <div class="driver-label">
              <label for="firstName">First Name<span class="custom-star">*</span></label>
              <input id="firstName" type="text" NoLeadingSpaceDirective pInputText placeholder="Enter First Name" maxlength="50" (keydown)="onKeyDown($event)"
                formControlName="firstName" />

            </div>
            <div class="
                error-outer">
              <div
                *ngIf="createDriverForm.get('firstName')?.hasError('required')  && (createDriverForm.get('firstName')?.dirty || createDriverForm.get('firstName')?.touched)">
                <div class="validation-error"> This field is required*</div>
              </div>

              <div
                *ngIf="createDriverForm.get('firstName')?.hasError('minlength')  && (createDriverForm.get('firstName')?.dirty || createDriverForm.get('firstName')?.touched)">
                <div *ngIf="!createDriverForm.get('firstName')?.hasError('pattern')" class="validation-error">Minimum 3
                  letters are required*</div>
              </div>

              <div
                *ngIf="createDriverForm.get('firstName')?.hasError('pattern')  && (createDriverForm.get('firstName')?.dirty || createDriverForm.get('firstName')?.touched)">
                <div class="validation-error"> Please enter only characters*</div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3">
          <div class="common-label">
            <div class="driver-label">
              <label for="lastName">Last Name<span class="custom-star">*</span></label>
              <input id="lastName" type="text"  NoLeadingSpaceDirective pInputText placeholder="Enter Last Name" maxlength="50" (keydown)="onKeyDown($event)"
                formControlName="lastName" />

            </div>
            <div class="
            error-outer">
              <div
                *ngIf="createDriverForm.get('lastName')?.hasError('required')  && (createDriverForm.get('lastName')?.dirty || createDriverForm.get('lastName')?.touched)">
                <div class="validation-error"> This field is required*</div>
              </div>
              
              <div
                *ngIf="createDriverForm.get('lastName')?.hasError('leadingSpace')  && (createDriverForm.get('lastName')?.dirty || createDriverForm.get('lastName')?.touched)">
                <div class="validation-error">Last Name cannot start with a space.*</div>
              </div>
              
              <div
                *ngIf="createDriverForm.get('lastName')?.hasError('minlength')  && (createDriverForm.get('lastName')?.dirty || createDriverForm.get('lastName')?.touched)">
                <div *ngIf="!createDriverForm.get('lastName')?.hasError('pattern')" class="validation-error">Minimum 3
                  letters are required*</div>
              </div>

              <div
                *ngIf="createDriverForm.get('lastName')?.hasError('pattern')  && (createDriverForm.get('lastName')?.dirty || createDriverForm.get('lastName')?.touched)">
                <div class="validation-error"> Please enter only characters*</div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3">
          <div class="common-label">
            <div class="driver-label">
              <label for="email">Email <span class="custom-star">*</span></label>
              <input id="email" type="text" pInputText placeholder="Enter Email ID" formControlName="email" />

            </div>
            <div class="
                    error-outer">
              <div
                *ngIf="createDriverForm.get('email')?.hasError('required')  && (createDriverForm.get('email')?.dirty || createDriverForm.get('email')?.touched)">
                <div class="validation-error"> This field is required*</div>
              </div>
              <div
                *ngIf="createDriverForm.get('email')?.hasError('pattern')  && (createDriverForm.get('email')?.dirty || createDriverForm.get('email')?.touched)">
                <div class="validation-error"> Please enter a valid email*</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3">
          <div class="common-label">
            <div class="driver-label drivermobile-number">
              <label for="phone">Mobile number <span class="custom-star">*</span></label>
              <div class="number-text">
                <ngx-intl-tel-input id="phone" [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                  [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                  [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]" [selectFirstCountry]="false"
                  [selectedCountryISO]="countryISO" [maxLength]="10" [phoneValidation]="true"
                  [separateDialCode]="separateDialCode" [numberFormat]="phoneNumberFormat.National" name="phone"
                  formControlName="phone">
                </ngx-intl-tel-input>

              </div>
              <div class="
                    error-outer">
                <div
                  *ngIf="!createDriverForm.get('phone').hasError('required') && createDriverForm.get('phone').touched && createDriverForm.get('phone').invalid">
                  <small class="validation-error">Mobile number is not valid*</small>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="grid top-margin">
        <div class="col-12 lg:col-3">
          <div class="common-label">
            <div class="driver-label">
              <label for="company">Company<span class="custom-star">*</span></label>
              <div class="common-dropdown">
                <p-dropdown id="company"
                  placeholder="Select Company" optionLabel="name" optionValue="id"
                  optionValue="value"></p-dropdown>
                <img src="assets/images/fill-dropdown.svg" alt=""/>
              </div>

            </div>
            <div class="
                error-outer">
              <div
                *ngIf="createDriverForm.get('firstName')?.hasError('required')  && (createDriverForm.get('firstName')?.dirty || createDriverForm.get('firstName')?.touched)">
                <div class="validation-error"> This field is required*</div>
              </div>

              <div
                *ngIf="createDriverForm.get('firstName')?.hasError('minlength')  && (createDriverForm.get('firstName')?.dirty || createDriverForm.get('firstName')?.touched)">
                <div *ngIf="!createDriverForm.get('firstName')?.hasError('pattern')" class="validation-error">Minimum 3
                  letters are required*</div>
              </div>

              <div
                *ngIf="createDriverForm.get('firstName')?.hasError('pattern')  && (createDriverForm.get('firstName')?.dirty || createDriverForm.get('firstName')?.touched)">
                <div class="validation-error"> Please enter only characters*</div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3">
          <div class="common-label">
            <div class="driver-label">
              <label for="parkingLot">Parking Lot<span class="custom-star">*</span></label>
              <div class="common-dropdown">
                <p-dropdown id="parkingLot"
                  placeholder="Select Parking Lot" optionLabel="name" optionValue="id"
                  optionValue="value"></p-dropdown>
                <img src="assets/images/fill-dropdown.svg" alt=""/>
              </div>

            </div>
            <div class="
            error-outer">
              <div
                *ngIf="createDriverForm.get('lastName')?.hasError('minlength')  && (createDriverForm.get('lastName')?.dirty || createDriverForm.get('lastName')?.touched)">
                <div *ngIf="!createDriverForm.get('lastName')?.hasError('pattern')" class="validation-error">Minimum 3
                  letters are required*</div>
              </div>

              <div
                *ngIf="createDriverForm.get('lastName')?.hasError('pattern')  && (createDriverForm.get('lastName')?.dirty || createDriverForm.get('lastName')?.touched)">
                <div class="validation-error"> Please enter only characters*</div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3">
          <div class="common-label">
            <div class="driver-label">
              <label for="status">Status <span class="custom-star">*</span></label>
                <div class="common-dropdown">
                  <p-dropdown id="status"
                    placeholder="Select Status" optionLabel="name" optionValue="id"
                    optionValue="value"></p-dropdown>
                  <img src="assets/images/fill-dropdown.svg" alt=""/>
                </div>

</div>
            <div class="
                    error-outer">
              <div
                *ngIf="createDriverForm.get('email')?.hasError('required')  && (createDriverForm.get('email')?.dirty || createDriverForm.get('email')?.touched)">
                <div class="validation-error"> This field is required*</div>
              </div>
              <div
                *ngIf="createDriverForm.get('email')?.hasError('pattern')  && (createDriverForm.get('email')?.dirty || createDriverForm.get('email')?.touched)">
                <div class="validation-error"> Please enter a valid email*</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3">
          <div class="driver-label custom-submit">

            <p-button label="Submit" type="submit" (onClick)="createDriverBySuperAdmin()" />

          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="note-outer">
    <p><span>Note:</span> After the successful submitting Parking Admin will automatically get login credentials</p>
  </div>
</div>